import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconList = memo(({ color = '#000', ...rest }) => {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        d="M22 20v2H2v-2h20zm0-6v2H2v-2h20zm0-6v2H2V8h20zm0-6v2H2V2h20z"
        fillRule="evenodd"
      />
    </Svg>
  );
});
